<template>
  <div>
    <v-btn
      v-show="GET_COTACOES_ID_PEDIDO.length > 0"
      color="primary"
      dark
      style="margin-top: 0.4em;"
      @click="abrirDialogCotacaoPedido()"
    >
      Ver cotações
    </v-btn>

    <Cotacao :pedido="pedido" ativacao_dialog_personalizada="ver" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Cotacao from "./Index.vue";

export default {
  components: { Cotacao },
  props: {
    pedido: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      GET_COTACOES_ID_PEDIDO: "CotacaoCarrinhoCompra/GET_COTACOES_ID_PEDIDO"
    })
  },
  methods: {
    ...mapMutations({
      SET_DIALOG_VER_COTACAO: "CotacaoCarrinhoCompra/SET_DIALOG_VER_COTACAO"
    }),
    abrirDialogCotacaoPedido() {
      this.SET_DIALOG_VER_COTACAO(true);
    }
  }
}
</script>

<style>

</style>
